import { clsx } from 'clsx'
import { type VFC } from 'react'

import { type Variant } from 'views/components/organisms/FilteredProductList/CompactProductListItem'
import CompactProductCardVariant, {
  type CompactProductCardVariantProps,
} from 'views/components/organisms/FilteredProductList/CompactProductListItem/CompactProductCardVariant'

import './CompactProductListItemVariant.scss'

type CompactProductListItemVariantProps = Omit<
  CompactProductCardVariantProps,
  'children'
> & {
  selected?: boolean
  variant: Variant
}

const CompactProductListItemVariant: VFC<
  CompactProductListItemVariantProps
> = props => {
  const { className, selected, variant, ...rest } = props

  const { unit, unitQuantityString } = variant

  return (
    <CompactProductCardVariant
      className={clsx(
        {
          'o-CompactProductListItemVariant': true,
          'o-CompactProductListItemVariant--selected': selected,
        },
        className
      )}
      {...rest}
    >
      {unitQuantityString} {unit}
    </CompactProductCardVariant>
  )
}

export default CompactProductListItemVariant
